// extracted by mini-css-extract-plugin
export var root = "ProductCollection-module--root--b594c";
export var content = "ProductCollection-module--content--0998d";
export var title = "ProductCollection-module--title--b48e6";
export var text = "ProductCollection-module--text--79158";
export var overlay = "ProductCollection-module--overlay--b5013";